
import React from "react";
import { formatDate } from "./utils";

interface PaymentConfirmationSectionProps {
  paymentConfirmed: boolean | null;
  paymentConfirmedAt: string | null;
  paymentConfirmedBy: string | null;
  isAdmin: boolean;
}

const PaymentConfirmationSection = ({
  paymentConfirmed,
  paymentConfirmedAt,
  paymentConfirmedBy,
  isAdmin
}: PaymentConfirmationSectionProps) => {
  // If payment isn't confirmed or we don't have permission to see details, don't show anything
  if (!paymentConfirmed || (!isAdmin && paymentConfirmedBy)) {
    return null;
  }

  return (
    <div>
      <h3 className="text-sm font-medium mb-1">Payment Confirmation</h3>
      <div className="bg-green-50 border border-green-200 rounded-md p-3">
        <p className="text-sm text-green-700">
          <span className="font-medium">Status:</span> Confirmed
          {paymentConfirmedAt && (
            <> on {formatDate(paymentConfirmedAt)}</>
          )}
        </p>
        
        {/* Only show confirmer details to admin users */}
        {isAdmin && paymentConfirmedBy && (
          <p className="text-sm text-green-700 mt-1">
            <span className="font-medium">Confirmed by:</span> {paymentConfirmedBy.substring(0, 8)}
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentConfirmationSection;
